import React, { Component } from 'react'
import { action, isObservableArray, toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import { Select } from 'antd'
import _sortBy from 'lodash/sortBy'
import _get from 'lodash/get'
import { Control, ControlSelect } from './styles'

// const MAX_PARAMS = 3

@inject('view')
@observer
class DataTypeControl extends Component {
  // UNSAFE_componentWillReceiveProps ({ view, category, dataTypes, kind }) { // eslint-disable-line
  //   const selectedTypes = view.getDataTypeIds({ kind, categoryId: category.id })
  //   const dataTypeIds = isObservableArray(selectedTypes) ? selectedTypes.toJS() : selectedTypes || []
  //   // console.log({ dataTypeIds })

  //   if (!dataTypeIds.length) {
  //     const defaultDataTypes = dataTypes.filter(dt => dt.default).map(dt => dt.id)
  //     this.handleDataTypeToggle(defaultDataTypes)
  //   }
  // }
  // @action.bound
  // handleDataTypeToggle (values) {
  //   const { view, category, kind } = this.props
  //   if (values.length <= MAX_PARAMS) {
  //     view.setDataTypeIds({
  //       kind,
  //       categoryId: category.id,
  //       dataTypeIds: values
  //     })
  //   }
  // }

  @action.bound
  handleDataTypeSelect (value) {
    const { view, category, kind } = this.props
    view.setDataTypeIds({
      kind,
      categoryId: category.id,
      dataTypeIds: [parseInt(value, 10)]
    })
  }

  render () {
    const { view, category, dataTypes, kind } = this.props
    const { name } = category
    const selectedTypes = view.getDataTypeIds({ kind, categoryId: category.id })
    const dataTypeIds = isObservableArray(selectedTypes) ? toJS(selectedTypes) : selectedTypes || []

    // const parameters = _sortBy(dataTypes, 'ranking').map(type => ({
    //   label: type.name,
    //   value: type.id
    // }))
    const [dataTypeId] = dataTypeIds
    // console.log({ dataTypes }, dataTypes.filter(dt => dt.default).map(dt => `${dt.id}`))
    return <Control style={{ background: 'none' }}>
      {name}
      <ControlSelect
        // options={parameters}
        onChange={this.handleDataTypeSelect}
        defaultValue={_get(dataTypes.find(dt => dt.default), 'id')}
        value={`${dataTypeId}`}
        style={{ width: '120px' }}
      >
        {_sortBy(dataTypes, 'ranking').map(type => {
          return (
            <Select.Option key={type.id} value={`${type.id}`}>
              {type.name}
            </Select.Option>
          )
        }
        )}
      </ControlSelect>
    </Control>
  }
}
export default DataTypeControl



// WEBPACK FOOTER //
// ./src/components/DataTypeSelectControl.js